import {State} from "./types";
import {setRequestStatus} from "../request-status";

export const initialState: State = {
  credits: [],
  pagination: {
    pos: 0,
    lim: 20,
    ser: "",
    hasMore: true,
  },
  request: {
    credits: setRequestStatus("initial"),
  },
};
